// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1NScl","requiredAsterisk":"Info_requiredAsterisk__3jGT_"};